import { Base } from '@studiometa/js-toolkit';

/**
 * CreatorsList component
 * Handles hover interaction to change the displayed image and creator card
 */
export default class CreatorsList extends Base {
  static config = {
    name: 'CreatorsList',
    refs: ['defaultImage', 'image[]', 'item[]', 'card[]', 'video[]'],
  };

  /**
   * Current active index (-1 = none)
   * @type {number}
   */
  activeIndex = -1;

  /**
   * Timeout for mouseleave delay
   * @type {number|null}
   */
  leaveTimeout = null;

  /**
   * Map of card index to video element
   * @type {Map<number, HTMLVideoElement>}
   */
  videos = new Map();

  /**
   * Initialize video references
   */
  mounted() {
    this.$refs.video?.forEach((wrapper) => {
      this.videos.set(Number(wrapper.dataset.index), wrapper.querySelector('video'));
    });
  }

  /**
   * Handle mouseenter on creator item
   * @param {object} props
   * @param {HTMLElement} props.target
   */
  onItemMouseenter({ target }) {
    clearTimeout(this.leaveTimeout);
    const index = Number(target.dataset.index);
    this.setActiveCreator(index);
  }

  /**
   * Handle mouseleave on creator item - reset to default with delay
   */
  onItemMouseleave() {
    this.leaveTimeout = setTimeout(() => {
      this.setActiveCreator(-1);
    }, 100);
  }

  /**
   * Set active creator by index
   * @param {number} index
   */
  setActiveCreator(index) {
    if (this.activeIndex === index) return;

    // Pause previous video if exists
    if (this.activeIndex !== -1) {
      const oldVideo = this.videos.get(this.activeIndex);
      if (oldVideo) {
        oldVideo.pause();
      }
    }

    this.activeIndex = index;

    if (index !== -1) {
      const newVideo = this.videos.get(index);
      if (newVideo) {
        newVideo.currentTime = 0;
        newVideo.play();
      }
    }

    if (this.$refs.defaultImage) {
      this.$refs.defaultImage.classList.toggle('is-active', index === -1);
    }

    this.$refs.image.forEach((img) => {
      const imgIndex = Number(img.dataset.index);
      img.classList.toggle('is-active', imgIndex === index);
    });

    this.$refs.item.forEach((item) => {
      const itemIndex = Number(item.dataset.index);
      const isActive = itemIndex === index;
      item.classList.toggle('is-active', isActive);

      const nameEl = item.querySelector('.section-creators__name');
      if (nameEl) {
        nameEl.classList.toggle('s:opacity-100', isActive);
        nameEl.classList.toggle('s:opacity-20', !isActive);
      }
    });

    this.$refs.card?.forEach((card) => {
      const cardIndex = Number(card.dataset.index);
      card.classList.toggle('is-active', cardIndex === index);
    });
  }
}
